import React from 'react';
import PropTypes from 'prop-types';
import NumberHelpers from 'number_helpers';
import StoreIcon from '../../../components/StoreIcon';

const Header = ({ selectedItem }) => {
  const { functions, installs } = selectedItem;
  const network = functions && SDK_FUNCTIONS[functions[0]];
  const installsNum = installs && NumberHelpers.number_with_delimiter(installs || 0);
  return (
    <div className="d-flex flex-column flex-wrap m-b-xs pt-md sdk-search-header">
      <div className="d-flex flex-row">
        <StoreIcon store={selectedItem.store} />
        <h2 className="ml-xs">{selectedItem.value}</h2>
      </div>
      <div className="pt-xxs">
        <p className="text-12 text-quiet">
          {network} | Current Installs: {installsNum}
        </p>
      </div>
      <div className="d-flex flex-row b-b justify-content-between pt-md pb-xxxs">
        <p className="text-12 text-quiet">Apps</p>
        <p className="text-12 text-quiet">Installed</p>
      </div>
    </div>
  );
};

Header.propTypes = {
  selectedItem: PropTypes.object,
};

export default Header;
